import React from 'react';
import classNames from 'classnames';
import './index.css';

export interface LabelWithSymbolsProps {
  text: string;
  className?: string;
}

const USABLE_SYMBOLS = {
  NEW_LINE: '\n',
  BR: '<br>',
  BR_REGEX: /<br[ ¥/]+>/,
  STRONG: '<strong>',
  STRONG_END: '</strong>',
};

const CSS_CLASSES = {
  STRONG: '__strong',
};

/**
 * 表示文字列に含まれてる特定シンボルをHTMLタグかつcssへ変換し表示する
 * 1. \n | <br> | </br> -> 一行として<p>タグで表示
 * 2. <strong> -> 行単位で強調表示 ※ 終了タグ不要
 */
const LabelWithSymbols: React.FC<LabelWithSymbolsProps> = ({ text, ...props }) => {
  const convertLineText = (text: string, index: number) => {
    const classes = [];
    let convertedText = text;
    if (text.includes(USABLE_SYMBOLS.STRONG)) {
      convertedText = text.split(USABLE_SYMBOLS.STRONG).join('').split(USABLE_SYMBOLS.STRONG_END).join('');
      classes.push(CSS_CLASSES.STRONG);
    }
    return (
      <p key={index} className={classNames(classes)}>
        {convertedText}
      </p>
    );
  };
  const textList = text
    .split(USABLE_SYMBOLS.NEW_LINE)
    .join(USABLE_SYMBOLS.BR)
    .split(USABLE_SYMBOLS.BR_REGEX)
    .join(USABLE_SYMBOLS.BR)
    .split(USABLE_SYMBOLS.BR);
  return <div {...props}>{textList.map((_text, _i) => (_text ? convertLineText(_text, _i) : <p key={_i}>&nbsp;</p>))}</div>;
};
export default LabelWithSymbols;
